// app/javascript/react_app/components/Addons/useAddons.ts
import { useCallback, useEffect } from 'react';

import { GLOBAL_EVENTS } from 'events/constants';

import { Addon } from './interface';

export const useAddons = ({
  subscription,
}: Pick<{ subscription: 'on' | null }, 'subscription'>) => {
  useEffect(() => {
    if (subscription) {
      window.setAddOns?.([]);
    }
  }, [subscription]);

  const handleHighlightedAddonSelectionChange = useCallback(
    ((event: CustomEvent) => {
      const { addon, isChecked } = event.detail;
      if (!addon) return;

      const current = (window.getAddOns?.() ?? []) as Addon[];
      const existing = current.find((a) => a.product_id === addon.product_id);

      let updated: Addon[];
      if (isChecked) {
        updated = existing ? current : [...current, { ...addon, quantity: 1 }];
      } else {
        updated = current.filter((a) => a.product_id !== addon.product_id);
      }
      window.setAddOns?.(updated);
    }) as EventListener,
    [],
  );

  useEffect(() => {
    document.addEventListener(
      GLOBAL_EVENTS.product.highlightedAddonSelectionChange,
      handleHighlightedAddonSelectionChange,
    );
    return () => {
      document.removeEventListener(
        GLOBAL_EVENTS.product.highlightedAddonSelectionChange,
        handleHighlightedAddonSelectionChange,
      );
    };
  }, [handleHighlightedAddonSelectionChange]);

  return {};
};
